import { ICache } from "@iconics/core";
import { appContext } from "../AppContext";

export class ApiCache implements IApiCache
{
    private cache: ICache;
    private get localStorage() { return appContext().localStorageProvider; }
    private get apiClient() { return appContext().apiClient; }

    constructor(cache: ICache)
    {
        this.cache = cache;
    }

//    public getSomethnig(...): Promise<...>
//    {
//        return this.cache.lazyGet(`...`, DateTime.now().plus({ days: ... }), () =>
//        {
//            const data = await appContext()...(...);
//            return data;
//        });
//    }
}

export interface IApiCache
{
//    getSomethnig(...): Promise<...>;
}
